import React from "react";

const DelayedButton = ({ children, delay, onClick, ...props }) => {
  const delayedOnClick = () => {
    setTimeout(() => onClick(), delay);
  };

  return (
    <div onClick={delayedOnClick} {...props}>
      {children}
    </div>
  );
};

DelayedButton.defaultProps = {
  delay: 250,
};

export default DelayedButton;
